import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ViewChildSsidHistoryModalComponent } from './view-child-ssid-history-modal/view-child-ssid-history-modal.component';

@Component({
    selector: 'app-view-child-ssid-history-btn',
    templateUrl: './view-child-ssid-history-btn.component.html',
    styleUrl: './view-child-ssid-history-btn.component.scss'
})
export class ViewChildSsidHistoryBtnComponent implements OnInit {
    @Input() studentId!: number;
    @Input() type: string = 'icon';

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {
        this.init();
    }

    init() {}

    openModal() {
        let payload: any = {};
        payload.studentId = this.studentId;

        const dialogConfig = new MatDialogConfig();
        //dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(ViewChildSsidHistoryModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                console.log(res.msg);
            }
        });
    }
}
